import type { ProgrammeEmailScheduleConfigRes } from '@dealstack/shared/lib/backendClient';

export enum CONFIG_CARD_FORM_FIELDS {
	enabled = 'enabled',
	initialDelayDays = 'initialDelayDays',
	intervalDays = 'intervalDays',
	maxFires = 'maxFires',
	endDate = 'endDate',
}

export interface ConfigCardFormValues {
	[CONFIG_CARD_FORM_FIELDS.enabled]: boolean;
	[CONFIG_CARD_FORM_FIELDS.initialDelayDays]: number;
	[CONFIG_CARD_FORM_FIELDS.intervalDays]: number;
	[CONFIG_CARD_FORM_FIELDS.maxFires]: number;
	[CONFIG_CARD_FORM_FIELDS.endDate]: Date | null;
}

export interface ConfigCardOnSave extends ConfigCardFormValues {
	type: ProgrammeEmailScheduleConfigRes['type'];
}
